import BaseApiService from './BaseApiService'
import store from '../store/index'

class UserService extends BaseApiService {
   constructor() {
      super()
   }

   async getUserByEmail(email) {
      store.commit('updateAuthInProgress', true)
      return super.execute('get', `user/byemail/${email}`)
   }
   
   async validateLink(link) {
      return super.executeAnon('get', `user/link/${link}`)
   }

   async getInvitationMultiLinkByEmail(email) {
      store.commit('updateAuthInProgress', true)
      return super.execute('get', `user/multiLinkByEmail/${email}`)
   }

   async updateProfile(profile) {
      return super.execute('post', `user/profile`, profile)
   }

   async createAppUser(payload) {
      return super.execute('post', `user/create`, payload)
   }

   async enableUser(payload) {
      return super.execute('post', `user/enable`, payload)
   }

   async updateUSR(payload) {
      return super.execute('post', `user/updateUSR`, payload)
   }

   async updateMD(payload) {
      return super.execute('post',`user/updateMD`, payload)
   }

   async isUserInvitationAccpeted(inviteId) {
      return super.execute('get',`user/userinvitationaccepted/${inviteId}`)
   }
   async createUserInvitation(payload) {
      return super.execute('post',"user/createUserInvitation",payload)
   }   
   
   async getPreferences(userid) {
      return super.execute('get',`user/prefs/${userid}`)
   }

   async savePreferences(payload) {
      return super.execute('post',"user/prefs",payload)
   }
   
   async createSubscriber(userid) {
      return super.execute('get',`user/subscribe/${userid}`)
   }
}

export let userApi = new UserService()